/* Aspire Linens – contact form: sends the inquiry to the Inquiry email (theme settings),
   and shows a clear "sent" message on the website. */
(function () {
  var body = document.body;
  var TO = body.dataset.contactEmail || 'info@aspirelinens.us';
  var OK_MSG = body.dataset.contactSuccess || 'Thank you! Your inquiry has been sent to our team.';
  var ALSO_SHOPIFY = body.dataset.contactShopify !== 'false';

  function isContactForm(f) {
    var t = f.querySelector('input[name="form_type"]');
    return t && t.value === 'contact';
  }

  function notice(form, text, isError) {
    var old = form.parentNode.querySelector('.aspire-sent-notice');
    if (old) old.remove();
    var n = document.createElement('div');
    n.className = 'aspire-sent-notice platform-status';
    n.setAttribute('role', isError ? 'alert' : 'status');
    n.setAttribute('tabindex', '-1');
    n.style.cssText = 'padding:16px 18px;margin:0 0 20px;border:1px solid ' + (isError ? '#b3261e' : '#2e7d32') +
      ';background:' + (isError ? '#fdecea' : '#edf7ee') + ';color:#1b1b1b;font-size:14px;line-height:1.6;';
    var strong = document.createElement('strong');
    strong.textContent = isError ? 'Message not sent. ' : 'Message sent. ';
    n.appendChild(strong);
    n.appendChild(document.createTextNode(text));
    form.parentNode.insertBefore(n, form);
    n.scrollIntoView({ behavior: 'smooth', block: 'center' });
    n.focus({ preventScroll: true });
  }

  function collect(form) {
    var data = {};
    new FormData(form).forEach(function (v, k) {
      var m = k.match(/^contact\[(.+)\]$/);
      if (m) data[m[1]] = v;
    });
    return data;
  }

  function postJson(payload) {
    return fetch('https://formsubmit.co/ajax/' + encodeURIComponent(TO), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) {
      return r.ok && j.success !== 'false' && j.success !== false;
    }); }).catch(function () { return false; });
  }

  /* Sends the same fields as multipart form data, with the product photo attached as a real file. */
  function postWithImage(payload, blob, productName) {
    var ext = (blob.type.split('/')[1] || 'jpg').replace('jpeg', 'jpg');
    var fileName = (productName || 'product').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase() + '.' + ext;
    var fd = new FormData();
    Object.keys(payload).forEach(function (k) { fd.append(k, payload[k]); });
    fd.append('attachment', blob, fileName);
    return fetch('https://formsubmit.co/ajax/' + encodeURIComponent(TO), {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: fd
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) {
      return r.ok && j.success !== 'false' && j.success !== false;
    }); }).catch(function () { return false; });
  }

  function sendToEmail(data) {
    var payload = {};
    Object.keys(data).forEach(function (k) { payload[k] = data[k]; });
    payload._subject = (data['Product'] ? 'Product inquiry – ' + data['Product'] : 'New website inquiry – Aspire Linens') + (data.name ? ' (' + data.name + ')' : '');
    payload._template = 'table';
    payload._captcha = 'false';
    if (data.email) payload._replyto = data.email;
    var imageUrl = data['Product image'];
    if (!imageUrl) return postJson(payload);
    /* try to attach the real product photo; if that is not possible, still send everything (with the image link) */
    return fetch(imageUrl, { mode: 'cors' })
      .then(function (r) { if (!r.ok) throw new Error('image'); return r.blob(); })
      .then(function (blob) {
        if (!blob || !blob.size || blob.size > 4.5 * 1024 * 1024) throw new Error('image size');
        return postWithImage(payload, blob, data['Product']).then(function (ok) { return ok || postJson(payload); });
      })
      .catch(function () { return postJson(payload); });
  }

  function sendToShopify(form) {
    return fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  /* ---- Product inquiry: show the chosen product on the form and send it with the email ---- */
  function addHidden(form, name, value) {
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = 'contact[' + name + ']'; i.value = value || '';
    form.appendChild(i);
  }

  function initProductInquiry() {
    var wanted = new URLSearchParams(location.search).get('product');
    if (!wanted) return;
    var form = document.querySelector('form input[name="form_type"][value="contact"]');
    form = form && form.form;
    if (!form || form.dataset.aspireProduct) return;
    form.dataset.aspireProduct = '1';

    var p = (window.aspireFindProduct && window.aspireFindProduct(wanted)) ||
            { name: wanted, spec: '', description: '', image: '' };

    var box = document.createElement('div');
    box.className = 'aspire-product-summary';
    box.style.cssText = 'display:flex;gap:16px;align-items:flex-start;padding:14px;margin:0 0 22px;border:1px solid rgba(0,0,0,.15);background:rgba(0,0,0,.03);';
    if (p.image) {
      var img = document.createElement('img');
      img.src = p.image; img.alt = p.name;
      img.style.cssText = 'width:110px;height:110px;object-fit:cover;flex:none;';
      box.appendChild(img);
    }
    var info = document.createElement('div');
    info.style.cssText = 'font-size:14px;line-height:1.6;';
    var lbl = document.createElement('div');
    lbl.textContent = 'INQUIRING ABOUT';
    lbl.style.cssText = 'font-size:11px;font-weight:700;letter-spacing:2px;margin-bottom:4px;';
    var h = document.createElement('strong');
    h.textContent = p.name; h.style.cssText = 'display:block;font-size:17px;';
    info.append(lbl, h);
    if (p.description) {
      var d = document.createElement('div');
      if (window.aspireRenderDescription) window.aspireRenderDescription(d, p.description);
      else { d.textContent = p.description; d.style.whiteSpace = 'pre-line'; }
      info.appendChild(d);
    }
    box.appendChild(info);
    form.insertBefore(box, form.firstChild);

    addHidden(form, 'Product', p.name);
    if (p.category) addHidden(form, 'Product category', p.category);
    if (p.spec) addHidden(form, 'Product specification', p.spec);
    if (p.description) addHidden(form, 'Product description', p.description);
    if (p.image) addHidden(form, 'Product image', p.image);
    addHidden(form, 'Product page', location.href);

    var topic = form.querySelector('select[name="contact[Inquiry topic]"]');
    if (topic) topic.value = 'Product question';
    var msg = form.querySelector('textarea[name="contact[body]"]');
    if (msg && !msg.value.trim()) {
      msg.value = 'Hello, I would like to inquire about "' + p.name + '". Please share pricing, availability and customization options.';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductInquiry);
  else initProductInquiry();

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !isContactForm(form) || form.dataset.aspireNative === '1') return;
    if (!form.checkValidity()) return;           /* let the browser show its own required-field messages */
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    var jobs = [sendToEmail(collect(form))];
    if (ALSO_SHOPIFY) jobs.push(sendToShopify(form));
    Promise.all(jobs).then(function (res) {
      var ok = res.some(Boolean);
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
      if (ok) { form.reset(); notice(form, OK_MSG, false); }
      else {
        /* both services failed: fall back to Shopify's normal form submit */
        form.dataset.aspireNative = '1';
        form.submit();
      }
    });
  }, true);
})();
